import React, { Component } from 'react'
import { useTranslation } from 'react-i18next'
import { observer } from 'mobx-react'
import 'styled-components/macro'
import {
   APIStatus,
   API_FETCHING,
   API_SUCCESS,
   API_FAILED
} from '@flowwai-frontend/shared/api-common'
import { getFormattedAPIErrorDescription } from '@flowwai-frontend/shared/utils/common'

// import ReactLoadingSkeleton from '../ReactLoadingSkeleton'

import LoadingView from './LoadingView'
import FailureView from './FailureView'
import { Container } from './styledComponents'

interface Props {
   renderLoadingView: () => JSX.Element
   renderFailureView: (onRetry: () => void, failureText: string) => JSX.Element
   apiStatus: APIStatus

   onRetry: () => void
   apiError: Error | null
   containerStyle: Record<string, any>
   // TODO: instead accept container css and classname
   containerCss?: React.CSSProperties
   containerClassName: string
   pathname?: string
   renderSuccessView?: React.ComponentType //TODO: render word refers to function type prop
   children?: React.ReactNode
}

const LoadingWrapperContent = observer((props: Props) => {
   const {
      renderFailureView,
      apiStatus,
      apiError,
      onRetry,
      renderSuccessView: RenderSuccessView = () => null,
      children
   } = props

   const { t } = useTranslation()

   const getLoaderView = () => {
      const { pathname, renderLoadingView } = props
      if (pathname) {
         return (
            // <ReactLoadingSkeleton loaderType={'ROUTE'} pathname={pathname} />
            <></>
         )
      } else {
         return renderLoadingView()
      }
   }

   const renderChildrenWithContainer = (children: any) => {
      const {
         containerClassName,
         containerStyle,
         pathname,
         apiStatus,
         containerCss
      } = props
      //NOTE:containerStyle and containerClassName has to be depricated
      if (pathname && apiStatus !== API_SUCCESS && apiStatus !== API_FAILED) {
         return children
      } else {
         return (
            <Container
               style={containerStyle}
               css={containerCss}
               className={containerClassName}
            >
               {children}
            </Container>
         )
      }
   }

   switch (apiStatus) {
      case API_FETCHING:
         return renderChildrenWithContainer(getLoaderView())
      case API_SUCCESS:
         return children ?? <RenderSuccessView />
      case API_FAILED: {
         //FIXME: need to pass i18n to getFormattedAPIErrorDescription
         const failureText = getFormattedAPIErrorDescription(apiError, t)
         return renderChildrenWithContainer(
            renderFailureView(onRetry, failureText)
         )
      }
      default:
         return renderChildrenWithContainer(getLoaderView())
   }
})

class LoadingWrapper extends Component<Props> {
   static defaultProps = {
      onRetry: () => 0,
      renderLoadingView: () => (
         <div data-testid='loader'>
            <LoadingView />
         </div>
      ),
      renderFailureView: (onRetry, failureText) => (
         <FailureView onRetry={onRetry} failureText={failureText} />
      ),
      containerClassName: '',
      containerStyle: {}
   }
   render() {
      return (
         <>
            <LoadingWrapperContent {...this.props} />
         </>
      )
   }
}

export default observer(LoadingWrapper)
